import React, { useContext } from "react";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Box, Typography } from "@material-ui/core";
import Text from "../../../shared/components/Text";
import { LenderIcon } from "../../loanApplication/SummaryAndAdjust/BorrowerSelectionLoanSummary/components/LenderSelectionItem";

export const AvailableLenders = ({ availableLenders, allLenders }) => {
  const {
    state: { agent },
  } = useContext(AuthContext);

  const { quota_selection_by_borrower_is_allowed } = agent;

  if (allLenders.length === 0) return null;

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      mt={quota_selection_by_borrower_is_allowed ? 0 : 2}
    >
      <Typography variant={"body2"}>
        <Text tId={"AVAILABLE_LENDERS"} />:
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        gridGap={12}
        mt={2}
        mb={1}
      >
        {allLenders.map((lender) => (
          <LenderIcon
            key={lender}
            lenderName={lender}
            size={22}
            isActive={availableLenders.includes(lender)}
          />
        ))}
      </Box>
    </Box>
  );
};
